__turbopack_context__.v({
  "label": "v18Tzq_label",
  "radioCheckBox": "v18Tzq_radioCheckBox",
});
